export default __webpack_public_path__ + "assets/images/social_media_bg.d38a7a3.png";